import axios from "axios";
import HttpException from "../common/exceptions/HttpException";
import { SSO_API_BASE_URL, SSO_REFRESH_TOKEN } from "../constants/APIConstants";

export const ssoRefreshToken = async (payload) => {
  const response = await axios
    .post(SSO_API_BASE_URL + SSO_REFRESH_TOKEN, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .catch(HttpException.create);
  return response.data;
};
